<style lang="scss">
.system-alert-template .ivu-avatar > * {
  line-height: 50px;
}
</style>
<style lang="scss" scoped>
.avatar-img {
  width: 50px;
  height: 50px;
  border-radius: 100%;
  /* float: left; */
  /* margin-right: 10px; */
}
.image-preview-container {
  height: 150px;
  overflow: hidden;
  text-align: center;
  background: #fff;
  width: 100%;
  margin: 0 auto;
}
.image-preview-container > img {
  height: 100%;
  width: auto;
  margin: 0 auto;
}

.image-preview-container2 {
  height: 130px;
  /* overflow: hidden; */
  text-align: center;
  background: #fff;
  width: 130px;
  margin: 0 auto;
  display: flex;
  .image{
    background-repeat: no-repeat !important;
    background-position: center !important;
    -webkit-background-size: cover !important;
    -moz-background-size: cover !important;
    -o-background-size: cover !important;
    background-size: cover !important;
    width:230px;
    height: 130px;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
  }
}
.title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}
.call-to-action-content {
  font-size: 12.5px;
  display: -webkit-box;
  -webkit-line-clamp: 10;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.document-content > b {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        font-size: 1em;
        line-height: 1.3em;
    }
    .document-content {
        width:100%;
        padding: 10px;
    }

    .section-label{
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        font-size: 0.9em;
        margin-top: 5px;
    }
</style>

<template>
  <div class="system-alert-template">
    <div style="max-height:70vh;overflow: scroll">
    <swiper v-show="presentation=='slideshow'" :options="systemSwiperOption" class="presentation" ref="systemSlider" @slideChange="getCurrentSlideIndex()">
      <swiper-slide v-for="(sharedActivity,k) in shareableActivityList.data" v-if="shareableActivityList.data.length > 0" :key="k" >
        <div :style="{padding: '10px 10px 8px'}">
          <Row type="flex" align="middle">
            <i-col :xs="5" :sm="3" :md="3" :lg="3">
              <Avatar class="avatar-img" style="border:1px solid #ddd;background: white;" :src="previewAvatar(sharedActivity)" size="large" />
              <!-- <Avatar v-if="sharedActivity.type !== 'call_to_action'" class="avatar-img" style="border:1px solid #ddd" :src="previewAvatar(sharedActivity)" size="large" /> -->
              <!-- <Avatar v-else class="avatar-img" style="border:1px solid #ddd" :src="postPreviewImage(sharedActivity)" size="large" /> -->
            </i-col>
            <i-col :xs="19" :sm="21" :md="21" :lg="21">
              <p style="font-size:14px; background: white; padding: 8px; border-radius: 4px;">
                <!-- <span v-if="sharedActivity.type !== 'call_to_action'" class="block-with-text"> -->
                <span class="block-with-text">
                  {{previewText(sharedActivity)}}
                  </span>
                <!-- <span v-else><h2>{{sharedActivity.title}}</h2></span> -->
              </p>
            </i-col>
            <!-- <i-col v-if="sharedActivity.type === 'call_to_action'" :span="24" style="padding:10px 0">
              <p class="call-to-action-content responsive-font-size-call-to-action" v-html="contentDisplay(sharedActivity)"></p>
            </i-col> -->
          </Row>
        </div>
        <!-- <div v-if="sharedActivity.type !== 'call_to_action'" style="margin:10px">
          <Row type="flex" justify="center"><i-col :span="24">
            <Card @click.native="viewActivity(sharedActivity)" dis-hover :style="{borderRadius: '0'}" :padding="0">
              <div class="feed-header" :style="{padding: '10px 10px 8px'}">
                <Row>
                  <i-col :xs="4" :sm="3" :md="3" :lg="3" style="display:flex;justify-content:center;margin-right:5px">
                    <Avatar v-if="sharedActivity.poster" shape="square" size="large" :src="getDisplayImage(sharedActivity.poster)"/>
                  </i-col>
                  <i-col :xs="19" :sm="20" :md="20" :lg="20">
                    <p style="font-size: 12px"><b class="title">{{sharedActivity.title}}</b></p>
                    <small style="color:#aaa;font-size:9px">
                      <timeago :since="sharedActivity.updated_at"></timeago>
                      <b v-if="section != 'journal' && section != 'group' && sharedActivity.group">
                      &middot; {{sharedActivity.group.title}}</b>
                    </small>
                  </i-col>
                </Row>
              </div>
              <div class="feed-content" style="position:relative">
                <div class="image-preview-container" v-if="sharedActivity.cover_photo && sharedActivity.type !== 'call_to_action'" style="position:relative">
                  <img :src="postPreviewImage(sharedActivity)" width="100%" alt="IMAGE">
                </div>
                <div style="padding:10px 15px;font-size: 12px">
                  <p class="block-with-text" v-html="contentDisplay(sharedActivity)"></p>
                </div>
              </div>
            </Card>
          </i-col></Row>
        </div> -->
        <!-- <div v-if="sharedActivity.type !== 'call_to_action'" style="margin-top:10px"> -->
        <div style="margin-top:10px">
          <Row type="flex" justify="center"><i-col :span="24">
            <Card v-if="sharedActivity.cover_photo_uri || (sharedActivity.data && sharedActivity.data.preview_image)" @click.native="viewActivity(sharedActivity)" dis-hover :style="{borderRadius: '0'}" :padding="0" >
              <div style="display:flex" >
                <div class="image-preview-container2" style="position:relative">
                  <div v-if="sharedActivity.cover_photo_uri" class="image" :style="{background: 'url('+ postPreviewImage(sharedActivity) +')'}"></div>
                  <div v-else class="image" :style="{background: 'url('+ sharedActivity.data.preview_image +')'}"></div>                  
                  <!-- <Avatar class="avatar-img" style="border:1px solid #ddd" :src="previewAvatar(sharedActivity)" size="large" /> -->
                </div>
                <div class="document-content">
                  <b>{{sharedActivity.title}}</b>
                  <p class="section-label block-with-text" v-html="contentDisplay(sharedActivity)"></p>
                  <small style="color:#aaa;font-size:9px">
                    <timeago :since="sharedActivity.updated_at"></timeago>
                    <b v-if="section != 'journal' && section != 'group' && sharedActivity.group">
                    &middot; {{sharedActivity.group.title}}</b>
                  </small>
                </div>
              </div>
            </Card>
            <Card v-else @click.native="viewActivity(sharedActivity)" dis-hover :style="{borderRadius: '0'}" :padding="0" >
              <div>
                <div style="display:flex">
                  <Avatar style="margin:8px; min-height: 40px;min-width: 40px;" v-if="sharedActivity.poster" shape="square" size="large" :src="getDisplayImage(sharedActivity.poster)"/>
                  <b class="section-label" style="word-break: break-word;margin-top:8px">{{sharedActivity.title}}</b>
                </div>
                <div style="padding: 0px 10px 10px">
                  <p class="section-label block-with-text" v-html="contentDisplay(sharedActivity)"></p>
                  <small style="color:#aaa;font-size:9px">
                    <timeago :since="sharedActivity.updated_at"></timeago>
                    <b v-if="section != 'journal' && section != 'group' && sharedActivity.group">
                    &middot; {{sharedActivity.group.title}}</b>
                  </small>
                </div>
              </div>
            </Card>
          </i-col></Row>
        </div>
      </swiper-slide>
      <!-- <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div> -->
    </swiper>
    </div>
  </div>
</template>

<script>
import tm from '@/assets/tapang-outline.png'
import _ from "lodash";
import Utils from '@/utils.js'
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
  name: 'SystemAlertComponent',
  components: {swiper, swiperSlide},
  props: {
    shareables: {
      required: true
    }
  },
  data() {
    return {
      section: 'none',
      tmImg: tm,
      presentation: 'slideshow',
      systemSwiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        keyboard: {
          enabled: true,
        },
        pagination: {
          el: '.swiper-pagination2',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  methods: {
    previewAvatar(sharedActivity) {
      if( sharedActivity && sharedActivity.data && sharedActivity.data.opt && sharedActivity.data.opt.avatar ){
        return process.env.VUE_APP_TEMP + sharedActivity.data.opt.avatar;
        // return _.get(sharedActivity.data, "opt.avatar", this.tmImg);
      }
      // else if(this.postPreviewImage(sharedActivity)){
      //   return this.postPreviewImage(sharedActivity)
      // }
      else 
        return this.tmImg;
    },
    previewText(sharedActivity) {
      if( sharedActivity )
        return _.get(sharedActivity.data, "opt.message", "We need your help. Please share this post to your Facebook Page.");
      else 
        return "We need your help. Please share this post to your Facebook Page.";
    },
    getCurrentSlideIndex() {    
      let index = this.swiper.activeIndex;
      this.$emit('currentSharedShown',index)
      // console.log(index);
    },
    viewActivity (item) {
      if(item.type == "call_to_action" && item.data && item.data.url){
        window.open(
          item.data.url,
          '_blank'
        );
      }else{
        this.$store.commit('systemAlert/setCurrentSystemShown',  this.swiper.activeIndex);
        this.$store.commit('feed/setSingleFeed', item)
        this.$router.push({ path: '/feed/' + item.id + "?scroll=false" })
      }
    },
    postPreviewImage (act) {
      if (act.cover_photo && act.cover_photo.length > 0 && 'medium' in act.cover_photo[0]) {
        return act.cover_photo[0]['medium']
      } else {
        return Utils.getDisplayImage('user', this.$store.state.user.brand, 'small')
      }
    },
    getDisplayImage(user) {
      return Utils.getDisplayImage('user', user, 'small')
    },
    contentDisplay (act) {
      switch (act.type) {
        case 'user_post':
          if (act.data) return act.data.text
          break
        case 'passport_expiration':
          return 'Passport Expiration'
          break
        case 'contract_expiration':
          return 'Contract Expiration'
          break
        case 'attachment':
          if (act.data) {
            switch (act.data.attachment_type) {
              case 'video':
                if (act.data.text || act.data.preview_summary) { return act.data.text || act.data.preview_summary }
                break
              case 'link':
                if (act.data.text || act.data.preview_summary) { return act.data.text || act.data.preview_summary }
                break
              default:
                if (act.data.text) return act.data.text
                break
            }
          }
          break
        case 'trivia':
          if (act.data && act.data.question) return act.data.question
          break
        case 'reveal':
          if (act.data && act.data.question) return act.data.question
          break
        case 'video': 
          if (act.data && act.data.text) { return act.data.text }
          break
        case 'recipe':
          if (act.data && act.data.description) { return '<a>View Recipe</a>' }
          break
        case 'call_to_action':
          if (act.data && act.data.text) {
            if (act.data.text.includes('$firstname')) return act.data.text.replace('$firstname', this.userInfo.display_name)
            else return act.data.text.replace(/(<([^>]+)>)/gi, '')
          }
          break
        default:
          if (act.data && act.data.tip) { return act.data.tip.replace(/(<([^>]+)>)/gi, '') }
          break
      }
      return ''
    },
  },
  computed: {
    shareableActivity: {
      get() { return this.shareables[0] }
    },
    shareableActivityList: {
      get() {
        return this.$store.state.systemAlert.shareableActivity
      }
    },
    userInfo: {
      get() { return this.$store.state.user.info }
    },
    getCurrentShown:{
      get(){
        return this.$store.state.systemAlert.currentSystemShown
      }
    },
    swiper: {
      get(){
        return this.$refs.systemSlider.swiper
      }
    }
  },
  mounted(){
    this.swiper.slideTo(this.getCurrentShown, 1000, true)
    this.getCurrentSlideIndex();
  }
}
</script>
